import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/homepage_header_poster.webp")